import {createAction} from '../../base/fsa';
import {ScenarioModel, ScenarioTriggerModel, STPUIEntity} from '../control/state';
import {UserRole, MediaModel, InputModel} from '../../types/control';
import {BackButtonModel, GroupSettingModel, MediaFileModel, ScenarioSettingModel} from './state';

export const setApplicationLoaded = createAction();

export const changeBusyAction = createAction(
    resolve =>
        (busy: boolean) =>
            resolve({busy}),
);

export const toggleScenarioScreenAction = createAction(
    resolve =>
        (scenario: ScenarioModel) =>
            resolve({scenario}),
);
export const toggleScenarioTriggerScreenAction = createAction(
    resolve =>
        (trigger: ScenarioTriggerModel) =>
            resolve({trigger}),
);

export const toggleScenarioTriggerInputScreenAction = createAction(
    resolve =>
        (input: InputModel) =>
            resolve({input}),
);

export const toggleScenarioPopupScreenAction = createAction(
    resolve =>
        (scenario: ScenarioModel) =>
            resolve({scenario}),
);

export const toggleScenarioTriggerPopupScreenAction = createAction(
    resolve =>
        (trigger: ScenarioTriggerModel) =>
            resolve({trigger}),
);

export const toggleScenarioSTPUIInputScreenAction = createAction(
    resolve =>
        (uiEntity: STPUIEntity) =>
            resolve({uiEntity}),
);

export const setMediaScreenAction = createAction(
    resolve =>
        (media: MediaModel, editMode?: boolean) =>
            resolve({media, editMode}),
);

export const setSTPUIMediaScreenAction = createAction(
    resolve =>
        (stpUIMedia: STPUIEntity) =>
            resolve({stpUIMedia}),
);

export const setAuthenticationAction = createAction(resolve => (role: UserRole) => resolve({role}));

export const setPopupScreenAction = createAction(resolve =>
    (visible: boolean, type?: 'info' | 'question' | 'success' | 'failure' | 'loading', message?: string, icon?: string, callback?: (isApproved: boolean) => void, closable = true, positive_button = {
        text: 'Evet',
        timed: false,
    }, showCancel = false) =>
        resolve({visible, message, icon, callback, type, closable, positive_button, showCancel}));

export const showMessageAction = (type: 'info' | 'success' | 'failure' | 'loading', message: string, icon?: string, closable = true) => setPopupScreenAction(true, type, message, icon, undefined, closable);

export const closePopupScreenAction = () => setPopupScreenAction(false);

export const setMediaFileListAction = createAction(
    resolve => (mediaFileList: MediaFileModel[]) => resolve({mediaFileList}),
);

export const alarmSettingUpAction = createAction(resolve => (isAlarmSettingUp: boolean) => resolve(isAlarmSettingUp));

export const setSelectedBackgroundAction = createAction(resolve => (selectedBackground: string) => resolve({selectedBackground}));

export const backButtonToggle = createAction(resolve => (backButton: BackButtonModel) => resolve({backButton}));

export const scenarioSettingAction = createAction(resolve => (scenarioSetting: ScenarioSettingModel) => resolve({scenarioSetting}));

export const scenarioSettingToggle = createAction(resolve => (scenarioSettingToggle: boolean) => resolve({scenarioSettingToggle}));

export const groupToggle = createAction(resolve => (groupToggle: boolean) => resolve({groupToggle}));

export const groupSettingAction = createAction(resolve => (groupSetting: GroupSettingModel) => resolve({groupSetting}));
